import { closestCenter, DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { arrayMove, SortableContext } from '@dnd-kit/sortable';
import { useEffect, useState } from 'react';

import { SortableCategoryItem } from './SortableCategoryItem';

export interface Item {
  id: number;
  order: number;
  name: string;
  viewable: number;
}

interface SortableCategoryTableProps<T> {
  data: T[];
  handleEditClick: (item: T) => void;
  onOrderChange?: (updatedItems: T[]) => void;
}

const SortableCategoryTable = <T extends Item>({
  data,
  handleEditClick,
  onOrderChange,
}: SortableCategoryTableProps<T>) => {
  const [sortableItems, setSortableItems] = useState(data);

  useEffect(() => {
    setSortableItems(data);
  }, [data]);

  return (
    <div>
      <div className='flex border border-solid border-gray-200 bg-gray-50'>
        <div className='w-[50px]'></div>
        <div className='w-[100px] px-3 py-[13px] text-left text-xs font-semibold'>表示順序</div>
        <div className='w-[calc((100%-280px)*0.7)] px-3 py-[13px] text-left text-xs font-semibold'>
          カテゴリ名
        </div>
        <div className='w-[calc((100%-280px)*0.3)] px-3 py-[13px] text-left text-xs font-semibold'>
          メニュー表示
        </div>
        <div className='w-[130px]'></div>
      </div>
      <DndContext
        collisionDetection={closestCenter}
        modifiers={[restrictToVerticalAxis]}
        onDragEnd={(event) => {
          const { active, over } = event;
          if (!over || active.id === over.id) {
            return;
          }

          const oldIndex = sortableItems.findIndex((item) => item.id === active.id);
          const newIndex = sortableItems.findIndex((item) => item.id === over.id);

          const newItems = arrayMove(sortableItems, oldIndex, newIndex).map((item, index) => ({
            ...item,
            order: index + 1,
          }));

          setSortableItems(newItems);
          if (onOrderChange) {
            onOrderChange(newItems);
          }
        }}
      >
        <SortableContext items={sortableItems}>
          {sortableItems
            .sort((a, b) => a.order - b.order)
            .map((item) => (
              <SortableCategoryItem
                key={item.id}
                item={item}
                handleEditClick={() => handleEditClick(item)}
              />
            ))}
        </SortableContext>
      </DndContext>
    </div>
  );
};

export default SortableCategoryTable;
